import React from 'react';

function Badge({ variant = 'info', children, style }) {
  return (
    <span className={`admin-badge admin-badge--${variant}`} style={style}>
      {children}
    </span>
  );
}

export default Badge;
